import React from 'react';

const Input = ({
    anteprima, 
    inputValues,
    handleOnChange,
    inputName,
    }) => {
    return (
        <>
            {!anteprima ? '(' : null}
            <span>{anteprima ? <span><span> </span> ({inputValues[inputName].valore}) <span> </span></span> : <input placeholder={inputValues[inputName].placeholder} type={inputValues[inputName].type} onChange={handleOnChange} id={inputValues[inputName].stile} name={inputName}/>}</span>
            {!anteprima ? ') ' : null}
        </>
        );
    }
export default Input;